import {
    LendingOutboundPackageVolumeHourDayHeatmapChart as LendingOutboundPackageVolumeHourDayHeatmapChartRenderer,
    hasChartSeries
} from '@frontend/chart/components';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import { useInsightHeatmapCellClick } from '../heatmap-cell-summary/use-insight-heatmap-cell-click';
import { InsightCardWidth } from '../insight-card-width';
import { InsightCard } from '../insight-card/insight-card.component';
import { useInsightChartMinHeight } from '../insight-detail-mode.context';
import { InsightId } from '../insight-registry/insight-ids';
import { useLendingOutboundPackageVolumeHourDayHeatmapChart } from './use-lending-outbound-package-volume-hour-day-heatmap-chart';

export interface LendingOutboundPackageVolumeHourDayHeatmapChartProps {
    accountId: string;
    width?: InsightCardWidth;
}

export const LendingOutboundPackageVolumeHourDayHeatmapChart = ({ accountId, width }: LendingOutboundPackageVolumeHourDayHeatmapChartProps) => {
    const chartMinHeight = useInsightChartMinHeight(280);
    const { data, isLoading, rangeStart, dayCount } = useLendingOutboundPackageVolumeHourDayHeatmapChart(accountId);
    const title = (
        <FormattedMessage
            id='platform.analytics.insights.lending-outbound-package-volume-hour-of-day-bar-chart.title'
            description='Title for the lending checkout hour-of-day peaks chart on analytics insights'
            defaultMessage='Peak checkout windows'
        />
    );
    const onCellClick = useInsightHeatmapCellClick({
        accountId,
        chartKey: LendingOutboundPackageVolumeHourDayHeatmapChartRenderer.definition.key,
        title
    });

    return (
        <InsightCard
            insightId={InsightId.LENDING_PEAK_CHECKOUT_WINDOWS}
            chartKey={LendingOutboundPackageVolumeHourDayHeatmapChartRenderer.definition.key}
            width={width}
            title={title}
            subtitle={
                <FormattedMessage
                    id='platform.analytics.insights.lending-outbound-package-volume-hour-day-heatmap-chart.subtitle'
                    description='Subtitle on the lending checkout heatmap indicating the chart covers the last 14 days'
                    defaultMessage='last 14 days'
                />
            }
            isLoading={isLoading}>
            {!hasChartSeries(data) || !data ? (
                <div className='text-foreground-default'>{CommonMessage.ERRORS.NO_DATA_AVAILABLE}</div>
            ) : (
                <div
                    className='w-full min-w-0 overflow-hidden'
                    style={{ height: chartMinHeight }}>
                    <LendingOutboundPackageVolumeHourDayHeatmapChartRenderer
                        data={data}
                        rangeStart={rangeStart}
                        dayCount={dayCount}
                        minHeight={chartMinHeight}
                        onCellClick={onCellClick}
                    />
                </div>
            )}
        </InsightCard>
    );
};
